/**
 * Generates the resource icon CSS class names
 *
 * @param {Object} resource - The resource object
 */
export function generateResourceIconClass(resource) {
    let className = 'room-resource-icon ';

    if (resource.permissions?.canCreateWithoutTransaction || resource.extendedProps?.canCreateWithoutTransaction) {
        className += ' bookable-without-transaction';
    } else if (resource.permissions?.canCreateRegular || resource.extendedProps?.canCreateRegular) {
        className += ' bookable-regular';
    } else if (resource.permissions?.canCreateWalkIn || resource.extendedProps?.canCreateWalkIn) {
        className += ' bookable-walk-in';
    } else {
        className += ' viewable';
    }

    if (resource.keyRequired || resource.extendedProps?.keyRequired) {
        className += ' fas fa-lock';
    } else {
        className += ' fa-regular fa-calendar';
    }

    return className;
}
